"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/products': {
    title: 'Products',
    view: 'Products',
    "public": true,
    locales: {
      az: '/az/products',
      en: '/en/products',
      ru: '/ru/products'
    }
  },
  '/az/products': {
    ref: '/products',
    lang: 'az',
    title: 'Məhsullar'
  },
  '/en/products': {
    ref: '/products',
    lang: 'en',
    title: 'Products'
  },
  '/ru/products': {
    ref: '/products',
    lang: 'ru',
    title: 'Продукты'
  },
  '/search': {
    title: 'Search',
    view: 'Search',
    "public": true,
    locales: {
      az: '/az/search',
      en: '/en/search',
      ru: '/ru/search'
    }
  },
  '/az/search': {
    ref: '/search',
    lang: 'az',
    title: 'Axtarış'
  },
  '/en/search': {
    ref: '/search',
    lang: 'en',
    title: 'Search'
  },
  '/ru/search': {
    ref: '/search',
    lang: 'ru',
    title: 'Поиск'
  },
  '/sale': {
    title: 'Sale',
    view: 'Sale',
    "public": true,
    locales: {
      az: '/az/sale',
      en: '/en/sale',
      ru: '/ru/sale'
    }
  },
  '/az/sale': {
    ref: '/sale',
    lang: 'az',
    title: 'Endirimlər'
  },
  '/en/sale': {
    ref: '/sale',
    lang: 'en',
    title: 'Sale'
  },
  '/ru/sale': {
    ref: '/sale',
    lang: 'ru',
    title: 'Скидки'
  },
  '/newin': {
    title: 'New arrivals',
    view: 'NewIn',
    "public": true,
    locales: {
      az: '/az/newin',
      en: '/en/newin',
      ru: '/ru/newin'
    }
  },
  '/az/newin': {
    ref: '/newin',
    lang: 'az',
    title: 'Yeniliklər'
  },
  '/en/newin': {
    ref: '/newin',
    lang: 'en',
    title: 'New arrivals'
  },
  '/ru/newin': {
    ref: '/newin',
    lang: 'ru',
    title: 'Новинки'
  },
  '/bestsellers': {
    title: 'Best sellers',
    view: 'BestSellers',
    "public": true,
    locales: {
      az: '/az/bestsellers',
      en: '/en/bestsellers',
      ru: '/ru/bestsellers'
    }
  },
  '/az/bestsellers': {
    ref: '/bestsellers',
    lang: 'az',
    title: 'Ən çox satılanlar'
  },
  '/en/bestsellers': {
    ref: '/bestsellers',
    lang: 'en',
    title: 'Best sellers'
  },
  '/ru/bestsellers': {
    ref: '/bestsellers',
    lang: 'ru',
    title: 'Самые продаваемые продукты'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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